<template>
	<div class="mb-14 flex h-96 w-full items-center justify-center">
		<div class="relative h-[72px] w-[72px]">
			<div class="carbar-animate-pulse absolute inset-0">
				<IconLoadingBg class="h-full w-full text-gray-500" />
			</div>
			<IconLoadingWhiteLogo
				class="absolute inset-0 h-full w-full text-gray-500"
			/>
		</div>
	</div>
</template>

<script setup>
import IconLoadingBg from '@/assets/svg/img-loading-bg.svg'
import IconLoadingWhiteLogo from '@/assets/svg/img-loading-white-logo.svg'
</script>
